<script lang="ts" setup>
import type { Breadcrumb } from '~/types/Catalog';

// TODO объединить два компонента с крошками в один

const props = defineProps<{ breadcrumbs?: Breadcrumb[] }>();

useJsonld({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: props.breadcrumbs?.slice(1).map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    item: { '@id': item.uri ?? makeUrlRelative(item.url), name: item.title },
  })),
} as any);
</script>

<template>
  <div
    v-if="breadcrumbs?.length"
    class="catalog-breadcrumbs"
  >
    <template
      v-for="(item, key) in breadcrumbs"
      :key="`${item.title}-${key}`"
    >
      <AppLink
        :to="item.uri ?? makeUrlRelative(item.url)"
        class="text-black last-of-type:break-words"
      >
        {{ item.title }}
      </AppLink>

      <SvgoChevronRight
        v-if="key !== breadcrumbs.length - 1"
        class="text-xs text-black-60"
        filled
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.catalog-breadcrumbs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  font-size: 12px;

  a {
    text-decoration: none;
  }
}
</style>
